import { LockResponse, SiteSystemType } from "api/ApiClient";
import { isGatewayDeviceType } from "constants/deviceTypes";

/**
 * Whether the Firmware & Hardware panel (which shows Device Type) is rendered
 * for this lock. `LockDetails.tsx` uses the complement of this to decide
 * whether to show Device Type / No Tour Enabled itself, so both call sites
 * must derive from this single source of truth to stay in sync.
 */
export const isFirmwarePanelVisible = (
  lock: Pick<LockResponse, "site" | "deviceType">,
): boolean =>
  lock.site?.account?.systemType === SiteSystemType.SchlageEngage &&
  !isGatewayDeviceType(lock.deviceType);
